/**

Coded by www.techhighway.ca

*/

// Material Dashboard 2 React base styles
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { grey, white, info } = colors;
const { borderRadius } = borders;
const { tabsBoxShadow } = boxShadows;

const tabs = {
  styleOverrides: {
    root: {
      position: "relative",
      // backgroundColor: grey[100],
      // borderRadius: borderRadius.xl,
      minHeight: "unset",
      padding: pxToRem(4),
      marginBottom: "15px",
      marginTop: "15px",
      "& .Mui-selected": {
        color: `${info.main} !important`,
      },
    },

    flexContainer: {
      height: "100%",
      position: "relative",
      zIndex: 10,
      flexWrap: "wrap",
    },

    fixed: {
      overflow: "unset !important",
      overflowX: "unset !important",
    },

    vertical: {
      "& .MuiTabs-indicator": {
        width: "100%",
      },
    },

    indicator: {
      // height: "100%",
      // borderRadius: borderRadius.lg,
      // backgroundColor: white.main,
      // boxShadow: tabsBoxShadow.indicator,
      // transition: "all 500ms ease",
      borderBottom: `3px solid ${info.main}`,
    },
  },
};

export default tabs;
